var path = 'app/scripts/modules/cloudfoundry/serverGroup/configure/wizard/templateSelection.html';
var html = "<deploy-initializer cloud-provider=\"cf\"\n                    command=\"command\"\n                    application=\"application\"\n                    parent-state=\"state\"\n                    on-template-selected=\"ctrl.templateSelected()\"></deploy-initializer>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/cloudfoundry/serverGroup/configure/wizard/templateSelection.html
// module id = 1655
// module chunks = 0